let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eIzhm"), load("c6MKV"), load("aZinD"), load("6qah4"), load("bMgpg"), load("iBa9k"), load("fbsPn")]).then(() => parcelRequire('64Kn9'));